import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './LoginForm.module.scss';
import { Button } from 'devextreme-react/button';
import TabPanel from 'devextreme-react/tab-panel';

import { Item } from 'devextreme-react/tab-panel';
import TextBox from 'devextreme-react/text-box';
import { iRootDispatch, iRootState } from '../../../../store/store';
import { FulogicsLogo } from 'fulogics-ui-web/dist/layout/assets/svg/FulogicsLogo';
import FramedBox from 'fulogics-ui-web/dist/layout/components/framed-box/FramedBox';
import { DekaTransLogo } from '../../../assets/DekaTransLogo';
import LoadPanel from 'devextreme-react/load-panel';
import { useWrappedAsync } from 'fulogics-ui-core';

const mapStateToProps = (state: iRootState) => ({} as LoginFormDisplayOptions);

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: LoginFormDisplayOptions) =>
    ({
        // TODO: login do store

        //
        ..._ownDispatch,
    } as LoginFormDisplayOptions);

const LoginForm = connect(
    mapStateToProps,
    mapDispatch as any
)((props: LoginFormProps) => {
    const { t } = useTranslation('LoginForm');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, handleLogin] = useWrappedAsync<[string, string], Promise<void> | void>(
        props.login
    );

    const onClickLoginButton = () => {
        handleLogin(username, password);
    };

    return (
        <div className={classNames(styles.container, props.className)}>
            <div className={classNames(styles.framedBox)}>
                <FramedBox title={t('loginFormTitle')} subtitle={t('loginFormSubtitle')} />
            </div>
            <div className={classNames(styles.bottomGroup)}>
                <TabPanel className={classNames(props.className)} width="280px">
                    <Item title={t('loginTitle')}>
                        <div className={classNames(styles.inputs, props.className)}>
                            <div>
                                <TextBox
                                    placeholder={t('loginPlaceholder')}
                                    value={username}
                                    onValueChanged={(e) => setUsername(e.value)}
                                />
                            </div>
                            <div className={classNames(styles.passwordDiv)}>
                                <TextBox
                                    mode="password"
                                    placeholder={t('passwordPlaceholder')}
                                    value={password}
                                    onValueChanged={(e) => setPassword(e.value)}
                                    showClearButton={true}
                                />
                            </div>
                        </div>
                    </Item>
                    <Item title={t('registrationTitle')} disabled={true} />
                </TabPanel>
                <div className={classNames(styles.buttons, props.className)}>
                    <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={loading} />
                    <div>
                        <Button
                            className={classNames(props.className, styles.loginButton)}
                            type="success"
                            onClick={onClickLoginButton}
                            text={t('loginButton')}
                            width="300px"
                        />
                    </div>
                    <div className={classNames(styles.passwordDiv)}>
                        <Button
                            // disabled={true}
                            className={classNames(styles.form, props.className)}
                            text={t('forgotPasswordButton')}
                            stylingMode="text"
                            width="300px"
                        />
                    </div>
                </div>
            </div>
            <div className={classNames(styles.bottomTitle)}>{t('bottomTitle')}</div>
            <div className={classNames(styles.bottomLogos)}>
                <FulogicsLogo className={classNames(styles.fulogicsLogo)} />
                <DekaTransLogo className={classNames(styles.dekatransLogo)} />
            </div>
        </div>
    );
});

export default LoginForm;
export type LoginFormProps = { data?: LoginFormData } & LoginFormDisplayOptions;

export class LoginFormDisplayOptions {
    className?: string;
    //
    login?: (username: string, password: string) => Promise<void>;
}

export type LoginFormData = {};
